// extracted by mini-css-extract-plugin
export default {"bg":"Winner_bg__TaZjl","win":"Winner_win__EG6mV"};